export default function($) {
  $('.form-error').attr('aria-invalid', 'true');

  const $formFields = $('input:not([type="hidden"]), select, textarea');

  $formFields.on('invalid', function() {
    $(this).attr('aria-invalid', 'true');
  });

  $formFields.on('input change', function() {
    if (this.checkValidity()) {
      $(this).removeAttr('aria-invalid');
    } else {
      $(this).attr('aria-invalid', 'true');
    }
  });
}
